import React, { ChangeEvent, useEffect, useState } from 'react';
import Layout from '../../../Layout';
import './AddRank.scss';
import { Form, Table, TableProps, TableColumnsType, Input, Breadcrumb, message, Button, InputNumber, InputNumberProps, Tabs, TabsProps, ConfigProvider, Pagination, PaginationProps, Switch, Select, Tooltip, Typography } from 'antd';
import { CrownOutlined, PlusOutlined } from '@ant-design/icons';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { SearchProps } from 'antd/es/input';
import * as BenefitApi from '../../../api/rank/benefitApi';
import * as RankApi from '../../../api/rank/rankApi';
import useToast from '../../../hook/useToast';
import TierBenefits from './ComponentAddRank/TierBenefits';
import { dataPagination } from '../../../until';
import { formatNumber } from '../../../services/mixin';
import viVN from 'antd/locale/vi_VN';
import useDebounce from '../../../hook/useDebounce';
import { useForm } from 'antd/lib/form/Form';
import { URL_RANK } from '../../../env';
import { gold_image } from '../../../components/ExportImgFigma';


const { Search } = Input;

const AddRank: React.FC = () => {

  const location = useLocation()

  const { id } = location?.state ?? {}



  useEffect(() => {
    document.title = 'THACO AUTO CRM';
    getListBenefit()

    if (id) {
      getInfoRank(Number(id))
    }
  }, []);


  const pushToast = useToast();
  const navigator = useNavigate()
  const [form] = useForm()

  const type = Form.useWatch('type', form);

  const [pagination, setPagination] = useState({ current: 1, pageSize: 20, total: 0 });
  const [paginationPolicies, setPaginationPolicies] = useState({ current: 1, pageSize: 20, total: 0 });
  const [paginationRankPolicies, setPaginationRankPolicies] = useState({ current: 1, pageSize: 20, total: 0 });
  const [searchValue, setSearchValue] = useState<string>('');
  const [searchValuePolicies, setSearchValuePolicies] = useState<string>('');
  const [searchValueRankPolicies, setSearchValueRankPolicies] = useState<string>('');

  const [valueNumber, setValueNumber] = useState<number>();
  const [dataBenefit, setDataBenefit] = useState<BenefitApi.DataTypeBenefit[]>([])
  const [dataBenefitPolicies, setDataBenefitPolicies] = useState<BenefitApi.DataTypeBenefit[]>([])
  const [dataRankPolicies, setDataRankPolicies] = useState<BenefitApi.DataTypeBenefit[]>([])
  const [listBenefits, setListBenefits] = useState<number[]>([])
  const [listRankPolicies, setListRankPolicies] = useState<number[]>([])
  const [listBenefitPolicies, setListBenefitPolicies] = useState<number[]>([])

  const [valueTab, setValueTab] = useState<string>('1');

  const handleSwitchChange = (checked: boolean, key: number) => {
    if (checked) {
      setListBenefits(prev => [...prev, key]);
    } else {
      setListBenefits(prev => prev.filter(id => id !== key));
    }
  };

  const handleSelectAll = (checked: boolean) => {
    if (checked) {
      setListBenefits(dataBenefit.map(item => item.key as number));
    } else {
      setListBenefits([]);
    }
  };

  const isAllSelected = dataBenefit.length > 0 && listBenefits.length === dataBenefit.length;




  const isAllSelectedPolicies = dataBenefitPolicies.length > 0 && listBenefitPolicies.length === dataBenefitPolicies.length;

  const handleSwitchChangePolicies = (checked: boolean, key: number) => {
    if (checked) {
      setListBenefitPolicies(prev => [...prev, key]);
    } else {
      setListBenefitPolicies(prev => prev.filter(id => id !== key));
    }
  };

  const handleSelectAllPolicies = (checked: boolean) => {
    if (checked) {
      setListBenefitPolicies(dataBenefitPolicies.map(item => item.key as number));
    } else {
      setListBenefitPolicies([]);
    }
  };

  const columns: TableColumnsType<BenefitApi.DataTypeBenefit> = [
    {
      title: () => (
        <Switch
          size='small'
          checked={isAllSelected}
          onChange={handleSelectAll}
        />
      ),
      dataIndex: 'key',
      align: 'center',
      render: (key: number) => (
        <Switch
          size='small'
          checked={listBenefits.includes(key)}
          onChange={(checked) => handleSwitchChange(checked, key)}
        />
      ),
    },
    // {
    //   title: 'STT',
    //   dataIndex: 'stt',
    //   align: 'center',
    //   sorter: {
    //     compare: (a, b) => a.stt - b.stt,
    //     multiple: 1,
    //   },
    // },
    {
      title: 'Mã quyền lợi',
      dataIndex: 'code',
      render: (text) => (
        <div className="t-name-ql">
          <span className="neutral-gray-500 text-2-row">{text}</span>
        </div>
      ),
    },
    {
      title: 'Tên quyền lợi',
      dataIndex: 'title',
      render: (text) => (
        <div className="t-name-ql">
          <div className="icon-svg"><CrownOutlined /></div>
          <span className="neutral-gray-500">{text}</span>
        </div>
      ),
    },
    {
      title: 'Mô tả quyền lợi dễ hiểu',
      dataIndex: 'description',
    },
  ];
  const columnsPolicies: TableColumnsType<BenefitApi.DataTypeBenefit> = [
    {
      title: () => (
        <Switch
          size='small'
          checked={isAllSelectedPolicies}
          onChange={handleSelectAllPolicies}
        />
      ),
      dataIndex: 'key',
      align: 'center',
      render: (key: number) => (
        <Switch
          size='small'
          checked={listBenefitPolicies.includes(key)}
          onChange={(checked) => handleSwitchChangePolicies(checked, key)}
        />
      ),
    },
    // {
    //   title: 'STT',
    //   dataIndex: 'stt',
    //   align: 'center',
    //   sorter: {
    //     compare: (a, b) => a.stt - b.stt,
    //     multiple: 1,
    //   },
    // },
    {
      title: 'Mã quyền lợi',
      dataIndex: 'code',
      render: (text) => (
        <div className="t-name-ql">
          <span className="neutral-gray-500 text-2-row">{text}</span>
        </div>
      ),
    },
    {
      title: 'Tên quyền lợi',
      dataIndex: 'title',
      render: (text) => (
        <div className="t-name-ql">
          <div className="icon-svg"><CrownOutlined /></div>
          <span className="neutral-gray-500">{text}</span>
        </div>
      ),
    },

 {
      title: 'Thương hiệu xe sở hữu',
      dataIndex: 'categoryCar',
      // minWidth: 180,
      // resizable: true,
      // flex: 1,
      render: (text) => (
        <Tooltip title={text} placement="topLeft">
          <div className="t-name-ql">
            <span className="neutral-gray-500 text-2-row">{text}</span>
          </div>
        </Tooltip>
      ),
    },

    {
      title: 'Mô tả quyền lợi dễ hiểu',
      dataIndex: 'description',
    },
  ];


  const isAllSelectedRankPolicies = dataRankPolicies.length > 0 && listRankPolicies.length === dataRankPolicies.length;

  const handleSwitchChangeRankPolicies = (checked: boolean, key: number) => {
    if (checked) {
      setListRankPolicies(prev => [...prev, key]);
    } else {
      setListRankPolicies(prev => prev.filter(id => id !== key));
    }
  };

  const handleSelectAllRankPolicies = (checked: boolean) => {
    if (checked) {
      setListRankPolicies(dataRankPolicies.map(item => item.key as number));
    } else {
      setListRankPolicies([]);
    }
  };

  const columnsRankPolicies: TableColumnsType<BenefitApi.DataTypeBenefit> = [
    {
      title: () => (
        <Switch
          size='small'
          checked={isAllSelectedRankPolicies}
          onChange={handleSelectAllRankPolicies}
        />
      ),
      dataIndex: 'key',
      align: 'center',
      render: (key: number) => (
        <Switch
          size='small'
          checked={listRankPolicies.includes(key)}
          onChange={(checked) => handleSwitchChangeRankPolicies(checked, key)}
        />
      ),
    },
    // {
    //   title: 'STT',
    //   dataIndex: 'stt',
    //   align: 'center',
    //   sorter: {
    //     compare: (a, b) => a.stt - b.stt,
    //     multiple: 1,
    //   },
    // },
    {
      title: 'Mã quyền lợi',
      dataIndex: 'code',
      render: (text) => (
        <div className="t-name-ql">
          <span className="neutral-gray-500 text-2-row">{text}</span>
        </div>
      ),
    },
    {
      title: 'Tên quyền lợi',
      dataIndex: 'title',
      render: (text) => (
        <div className="t-name-ql">
          <div className="icon-svg"><CrownOutlined /></div>
          <span className="neutral-gray-500">{text}</span>
        </div>
      ),
    },
    {
      title: 'Mô tả quyền lợi dễ hiểu',
      dataIndex: 'description',
      render: (text) => (
        <Tooltip
          title={text}
          color="#fff"
          styles={{
            body: {
              color: "#000",
            },
          }}
        >
          <Typography.Paragraph
            className=' font-regular'
            ellipsis={{ rows: 2 }}
            style={{ marginBottom: 0, fontSize: 16, color: '#667085' }}
          >
            {text}
          </Typography.Paragraph>
        </Tooltip>
      ),
    },
    {
      title: 'Ngày bắt đầu',
      dataIndex: 'dateStart',
    },
    {
      title: 'Ngày kết thúc',
      dataIndex: 'dateEnd',
    },
  ];

  const onChange = (key: string) => {
    setValueTab(key);
  };


  const getInfoRank = async (id: number) => {
    const result = await RankApi.getInfoRank(id);
    if (result.status) {
      form.setFieldValue('title', result.data.title)
      form.setFieldValue('totalAmount', result.data.totalAmount)
      // form.setFieldValue('code', result.data.code)
      form.setFieldValue('img', result.data.icon)
      form.setFieldValue('totalAmount', result.data.totalAmount)
      form.setFieldValue('code', result.data.code)
      form.setFieldValue('sortOrder', result.data.sortOrder)
      form.setFieldValue('type', result.data.type)
      form.setFieldValue('totalPurchaseAmount', result.data.totalPurchaseAmount)
      form.setFieldValue('logicOperator', result.data.logicOperator)
      form.setFieldValue('totalServiceAmount', result.data.totalServiceAmount)


      setExistingIcon(result.data.icon)
      setListBenefits(result.data.benefits.map(item => item.id))
      setListBenefitPolicies(result.data.benefitPolicies.map(item => item.id))
      if (result.data.carePolicies) {
        setListRankPolicies(result.data.carePolicies.map((item: any) => item.id))
      }
    } else {
      pushToast(result.message, "error", 2000)
    }
  }

  const getListBenefit = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    const result = await BenefitApi.getListBenefit(pageSize, pageCurent, searchValue, undefined, 1);
    if (result?.status) {
      setDataBenefit(convertData(result.data))
      setPagination({ current: pageCurent, total: result.total, pageSize: pageSize })

    } else {
      pushToast(result?.message, 'error', 2000)
    }
  }, 500)

  const getListBenefitPolicies = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    const result = await BenefitApi.getListBenefitPolicies(pageSize, pageCurent, searchValuePolicies, undefined, 1);
    if (result?.status) {
      setDataBenefitPolicies(convertData(result.data))
      setPaginationPolicies({ current: pageCurent, total: result.total, pageSize: pageSize })

    } else {
      pushToast(result?.message, 'error', 2000)
    }
  }, 500)

  const getListCarePolicies = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    const result = await RankApi.getListCarePolicies(pageSize, pageCurent, searchValueRankPolicies);
    if (result?.status) {
      setDataRankPolicies(convertDataV2(result.data))
      setPaginationRankPolicies({ current: pageCurent, total: result.total, pageSize: pageSize })

    } else {
      pushToast(result?.message, 'error', 2000)
    }
  }, 500)

  const convertData = (data: BenefitApi.IBenefit[] | RankApi.IRankPolicie[]) => {
    var stt = 1;
    const convertData = data.map((item) => ({
      key: item.id,
      stt: stt++,
      code: item.code,
      title: item.title,
      description: item?.description,
      categoryCar: item.categoryCar,
      // status: item?.status
    }))
    return convertData
  }

  const convertDataV2 = (data: RankApi.IRankPolicie[]) => {
    var stt = 1;
    const convertData = data.map((item) => ({
      key: item.id,
      stt: stt++,
      code: item.code,
      title: item.title,
      description: item?.benefitPolicyNames,
      dateStart: item?.dateStart,
      dateEnd: item?.dateEnd,
      // status: item?.status
    }))
    return convertData
  }


  const onFinish = async (values: any) => {
    const result = await RankApi.addRank(
      values.title, values.code, values.totalAmount, uploadedFile,
      values.totalServiceAmount, values.totalPurchaseAmount, values.totalOwnerVehicles,
      values.logicOperator, values.sortOrder, values.type,
      listBenefits, listBenefitPolicies, listRankPolicies
    );
    if (result?.status) {
      pushToast("Thêm mới thành công!", "success", 2000)
      navigator(-1)
      // getListRegions()
    } else {
      pushToast(result?.message, "error", 2000)

    }
  };

  const onFinishFailed = (errorInfo: any) => {
  };

  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [existingIcon, setExistingIcon] = useState<string | null>(null);

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0] || null;

    if (file) {
      const isLt1M = file.size / 1024 / 1024 < 1; // Kiểm tra xem kích thước tập tin có nhỏ hơn 1MB không
      if (!isLt1M) {
        // message.error('Ảnh phải nhỏ hơn 1MB!');
        pushToast('Ảnh phải nhỏ hơn 1MB!', 'error', 2000)

      } else {
        setUploadedFile(file);
      }
    }
  };

  const handleUploadClick = (event: React.MouseEvent) => {
    event.preventDefault();
    const inputElement = document.querySelector('input[type="file"]') as HTMLInputElement | null;
    if (inputElement) {
      inputElement.click();
    }
  };

  const onSearch: SearchProps['onSearch'] = (value, _e, info) => {
    setSearchValue(value);
  }

  const onSearchPolicies: SearchProps['onSearch'] = (value, _e, info) => {
    setSearchValuePolicies(value);
  }

  const onSearchRankPolicies: SearchProps['onSearch'] = (value, _e, info) => {
    setSearchValueRankPolicies(value);
  }

  const onPaginationChangePolicies: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    getListBenefitPolicies(pageNumber, pageSize)
  }
  const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    getListBenefit(pageNumber, pageSize)
  }
  const onPaginationChangeRankPolicies: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    getListCarePolicies(pageNumber, pageSize)
  }

  useEffect(() => {
    getListBenefit()
  }, [searchValue]);

  useEffect(() => {
    getListBenefitPolicies()
  }, [searchValuePolicies]);

  useEffect(() => {
    getListCarePolicies()
  }, [searchValueRankPolicies]);

  return (
    <div className="marketing-campaigns marketing-campaigns-detail add-rank-page">
      <Layout>
        <Breadcrumb
          items={[
            {
              title: 'THACO AUTO CRM',
            },
            {
              title: <a href="/">Cấu hình</a>,
            },
            {
              title: <a href="/">Quản lý phân hạng</a>,
            },
            {
              title: 'Tạo mới hạng thành viên',
            },
          ]}
        />

        <div className='title-page title-btn-back ctrl-title-vouche'>
          <Link to="/member-card/class-list" className="icon-svg">
            <svg width="1em" height="1em" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.6564 7.80321H4.04305L10.3955 2.37463C10.4971 2.28713 10.4354 2.12463 10.3012 2.12463H8.69582C8.62508 2.12463 8.55796 2.14963 8.50536 2.19428L1.65045 8.04963C1.58767 8.10321 1.53732 8.16944 1.50281 8.24385C1.4683 8.31825 1.45044 8.39909 1.45044 8.48088C1.45044 8.56268 1.4683 8.64352 1.50281 8.71792C1.53732 8.79233 1.58767 8.85856 1.65045 8.91213L8.54526 14.8032C8.57247 14.8264 8.60512 14.8389 8.63959 14.8389H10.2993C10.4336 14.8389 10.4953 14.6746 10.3937 14.5889L4.04305 9.16035H14.6564C14.7363 9.16035 14.8016 9.09606 14.8016 9.01749V7.94606C14.8016 7.86749 14.7363 7.80321 14.6564 7.80321Z" fill="currentColor" fillOpacity="0.88" />
            </svg>
          </Link>
          Tạo mới hạng thành viên
        </div>

        <div className="content-add-rank">
          <div className="form-add-rank">
            <div className="title-fz16-medium t-mb-18">Thiết lập thông tin</div>
            <Form
              className="form-block custom-page-css flex flex-col gap-2"
              initialValues={{
                remember: true,
                type: 1
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              layout="vertical"
              form={form}


            >

              <Form.Item
                name="img"
                rules={[{ required: true, message: 'Vui lòng thêm hình!' }]}
              >
                <div className="input-block">
                  {
                    uploadedFile
                      ? (
                        <div className="avatar-uploader-block">
                          <input
                            type="file"
                            accept="image/*"
                            onChange={handleFileChange}
                            style={{ display: 'none' }}
                          />
                          <img src={URL.createObjectURL(uploadedFile)} alt="Uploaded" className="avatar-uploader" onClick={handleUploadClick} />
                        </div>

                      ) : (
                        <div className="avatar-uploader-block">
                          <input
                            type="file"
                            accept="image/*"
                            onChange={handleFileChange}
                            style={{ display: 'none' }}
                          />
                          {existingIcon ? (
                            <img
                              src={URL_RANK + existingIcon}
                              alt="Uploaded"
                              className="w-64-px h-64-px ob-cover rounded-100-px cursor-pointer"
                              onError={(e) => { e.currentTarget.src = gold_image; }}
                              onClick={handleUploadClick}
                            />
                          ) : (
                            <div className="avatar-uploader avatar-uploader-none-img" onClick={handleUploadClick}>
                              <div className="icon-svg"><PlusOutlined /></div>
                              <div className="text">Tải lên Icon <br /> của hạng</div>
                            </div>
                          )}
                        </div>
                      )
                  }
                </div>
              </Form.Item>
              <Form.Item
                label="Mã hạng"
                name="code"
                rules={[{ required: true, message: 'Mã hạng không được để trống!' }]}
              >
                <Input placeholder="Vui lòng nhập mã hạng" className='custom-input-css custom-page-css border ' />
              </Form.Item>
              <Form.Item
                label="Tên hạng"
                name="title"
                rules={[{ required: true, message: 'Tên hạng không được để trống!' }]}
              >
                <Input placeholder="Vui lòng nhập tên hạng" className='custom-input-css custom-page-css border ' />
              </Form.Item>
              <Form.Item
                label="Thứ tự ưu tiên"
                name="sortOrder"
                rules={[
                  { required: true, message: 'Thứ tự ưu tiên không được để trống!' },
                  {
                    type: 'number',
                    min: 0,
                    transform: (value) => Number(value),
                    message: 'Thứ tự ưu tiên phải lớn hơn hoặc bằng 0!',
                  },
                ]}
              >
                <Input
                  type="number"
                  min={0}
                  placeholder="Vui lòng nhập thứ tự ưu tiên"
                  className="custom-input-css custom-page-css border"
                />
              </Form.Item>
              <Form.Item
                label="Số lượng xe sở hữu"
                name="totalOwnerVehicles"
                rules={[
                  {
                    required: true,
                    message: 'Số lượng xe sở hữu không được để trống!',
                  },
                  {
                    validator: (_, value) => {
                      if (value === undefined || value === null || value === '') {
                        return Promise.resolve();
                      }

                      const numberValue = Number(value);

                      if (!Number.isInteger(numberValue)) {
                        return Promise.reject(
                          new Error('Số lượng xe sở hữu phải là số nguyên!')
                        );
                      }

                      if (numberValue < 0) {
                        return Promise.reject(
                          new Error('Số lượng xe sở hữu phải lớn hơn hoặc bằng 0!')
                        );
                      }

                      if (numberValue > 9999999999) {
                        return Promise.reject(
                          new Error('Số lượng xe sở hữu không được vượt quá 10 chữ số!')
                        );
                      }

                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input
                  type="number"
                  min={0}
                  max={9999999999}
                  step={1}
                  placeholder="Vui lòng nhập số lượng xe sở hữu"
                  className="custom-input-css custom-page-css border"
                />
              </Form.Item>
              <Form.Item
                label="Loại điều kiện xếp hạng"
                name="type"
              >
                <Select
                  placeholder="Chọn loại điều kiện"
                  className='custom-page-css border rounded overflow-hidden'
                  options={[
                    { value: 1, label: 'Theo tổng chi tiêu' },
                    { value: 2, label: 'Theo tổng chi tiêu mua xe và dịch vụ' }
                  ]}
                />
              </Form.Item>

              {type === 1
                ?
                <Form.Item
                  label="Số tiền chi tiêu để đạt được hạng"
                  name="totalAmount"
                  rules={[{ required: true, message: 'Số tiền không được để trống!' }]}
                >
                  <InputNumber<number>
                    className="w-full"
                    min={0}
                    addonAfter="VNĐ"
                    formatter={(value) =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                    }
                    parser={(value) =>
                      value?.replace(/\./g, '') as unknown as number
                    }
                  />
                </Form.Item>
                :
                <>
                  <Form.Item
                    label="Tổng chi tiêu mua xe tối thiểu"
                    name="totalPurchaseAmount"
                  >

                    <InputNumber<number>
                      className="w-full"
                      min={0}
                      addonAfter="VNĐ"
                      formatter={(value) =>
                        `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                      }
                      parser={(value) =>
                        value?.replace(/\./g, '') as unknown as number
                      }
                    />
                  </Form.Item>

                  <Form.Item
                    label="Logic kết hợp các điều kiện lọc"
                    name="logicOperator"
                  >
                    <Select
                      placeholder="Chọn loại điều kiện"
                      className='custom-page-css border rounded overflow-hidden'
                      options={[
                        { value: 'AND', label: ' Thỏa mãn tất cả các điều kiện (AND)' },
                        { value: 'OR', label: ' Thỏa mãn một trong các điều kiện (OR)' }
                      ]}
                    />
                  </Form.Item>
                  <Form.Item
                    label="Tổng chi tiêu dịch vụ tối thiểu"
                    name="totalServiceAmount"
                  >
                    <InputNumber<number>
                      className="w-full"
                      min={0}
                      addonAfter="VNĐ"
                      formatter={(value) =>
                        `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                      }
                      parser={(value) =>
                        value?.replace(/\./g, '') as unknown as number
                      }
                    />
                  </Form.Item>
                </>
              }

              <Form.Item>
                <div className="btn-block">
                  <Button className="btn btn-primary" type="primary" htmlType="submit">
                    <div className="text">
                      Thêm hạng
                    </div>
                  </Button>
                </div>
              </Form.Item>
            </Form>
          </div>

          <div className="detail-block t-mt-0">
            <Tabs
              defaultActiveKey={valueTab}
              items={[
                {
                  key: '1',
                  label: <span className='text-base font-regular'>Quyền lợi hạng</span>,
                  children:
                    <TierBenefits
                      dataBenefit={dataBenefit}
                      onSearch={onSearch}
                      columns={columns}
                    />
                },
                {
                  key: '2',
                  label: <span className='text-base font-regular'>Chính sách CSKH</span>,
                  children:
                    <TierBenefits
                      dataBenefit={dataRankPolicies}
                      onSearch={onSearchRankPolicies}
                      columns={columnsRankPolicies}
                    />
                },
                {
                  key: '3',
                  label: <span className='text-base font-regular'>Quyền lợi chăm sóc khách hàng</span>,
                  children:
                    <TierBenefits
                      title="Quyền lợi hạng thẻ khách hàng"
                      dataBenefit={dataBenefitPolicies}
                      onSearch={onSearchPolicies}
                      columns={columnsPolicies}
                    />
                }
              ]}
              onChange={onChange} />


          </div>
        </div>
        <div className="custom-page-css w-full mt-auto">
          <ConfigProvider locale={viVN}>
            <div className="pagination-block">
              <Pagination
                className='rs-pagination'
                showSizeChanger
                current={valueTab === '1' ? pagination.current : paginationPolicies.current}
                pageSize={valueTab === '1' ? pagination.pageSize : paginationPolicies.pageSize}
                total={valueTab === '1' ? pagination.total : paginationPolicies.total}
                pageSizeOptions={['10', '20', '50', '100']}
                itemRender={(page, type, originalElement) => {
                  // Chỉ custom khi là nút số trang
                  if (type === 'page') {
                    return <span>{formatNumber(page)}</span>;
                  }
                  // prev / next / jump-prev / jump-next giữ nguyên
                  return originalElement;
                }}
                showTotal={(total) => `Tổng cộng ${dataPagination(valueTab === '1' ? pagination.total : paginationPolicies.total, valueTab === '1' ? pagination.pageSize : paginationPolicies.pageSize, valueTab === '1' ? pagination.current : paginationPolicies.current).totalPage} trang`}
                onChange={valueTab === '1' ? onPaginationChange : valueTab === '2' ? onPaginationChangePolicies : onPaginationChangeRankPolicies}
              />
            </div>
          </ConfigProvider>
        </div>
      </Layout>
    </div>
  );
}

export default AddRank;
